// Конфигурация для React приложения
// Если приложение работает не на localhost, используем текущий домен и Nginx-прокси
const isBrowser = typeof window !== "undefined";
const isLocalhost =
  isBrowser &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

// Поддержка переопределения адресов через переменные окружения (CRA):
// REACT_APP_API_URL — полный URL API (включая /api/v1)
// REACT_APP_WS_URL  — полный URL WebSocket (ws://.../ws или wss://.../ws)
const ENV_API_URL = process.env.REACT_APP_API_URL;
const ENV_WS_URL = process.env.REACT_APP_WS_URL;
const ENV_PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;
const REMOTE_ORIGIN = (() => {
  try {
    return (
      ENV_PUBLIC_BASE_URL?.trim() ||
      (ENV_API_URL ? new URL(ENV_API_URL).origin : undefined)
    );
  } catch {
    return undefined;
  }
})();

export const API_CONFIG = {
  BASE_URL:
    isBrowser && !isLocalhost
      ? window.location.origin
      : "http://localhost:5001",
  API_VERSION: "v1",
  WEBSOCKET_URL:
    ENV_WS_URL ||
    (isBrowser && !isLocalhost
      ? `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}/ws`
      : "ws://localhost:8765"),
};

export const PUBLIC_BASE_URL =
  REMOTE_ORIGIN ||
  (isBrowser && !isLocalhost ? window.location.origin : "http://localhost:5001");

// Полный URL для API
export const API_BASE_URL =
  ENV_API_URL || `${API_CONFIG.BASE_URL}/api/${API_CONFIG.API_VERSION}`;

// REACT_APP_API_V2_URL — полный URL API v2; по умолчанию выводится из API_BASE_URL
export const API_V2_BASE_URL =
  process.env.REACT_APP_API_V2_URL || API_BASE_URL.replace(/\/v1\/?$/, "/v2");

// Определяем базовый URL для редиректов OAuth (используем фактический origin)
const getBaseUrl = () =>
  REMOTE_ORIGIN ||
  (isBrowser ? window.location.origin : "http://localhost:3000");

// OAuth конфигурация
export const OAUTH_CONFIG = {
  google: {
    clientId:
      "941970089498-4ov6gr438k0d00f4mp4pmlkriugjvfbg.apps.googleusercontent.com",
    scope: "openid email profile",
    authUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    redirectUri: `${getBaseUrl()}/login/google/authorized`,
  },
  facebook: {
    appId: "639112515712716",
    scope: "email",
  },
  twitter: {
    clientId: "WbRgdRqMe3oEzixKVtBN1TDmF",
    scope: "users.read",
    authUrl: "https://twitter.com/i/oauth2/authorize",
    redirectUri:
      process.env.NODE_ENV === "production"
        ? `${getBaseUrl()}/twitter/callback`
        : "http://localhost:5001/twitter/callback",
    enabled: true,
    appId: "30473596",
  },
  reddit: {
    clientId: "dja29Egv1AJ_ZX7ij3S8Dg",
    scope: "identity",
    redirectUri:
      process.env.NODE_ENV === "production"
        ? `${getBaseUrl()}/login/reddit/authorized`
        : "http://localhost:3000/login/reddit/authorized",
  },
};
